export enum AssessmentWeightType {
  Porcentagem,
  Peso,
}
